/**
 * Labstep
 *
 * @module prosemirror/extensions/referencing
 * @desc Referencing extension
 */

import { REFERENCING_TRIGGER } from 'labstep-web/constants/prosemirror';
import type { LabstepExtension } from '../types';
import {
  handleArrowDown,
  handleArrowUp,
  handleEnter,
  handleEscape,
  handleTrigger,
} from './commands';
import referencingPlugin from './plugin';

export const ExtensionReferencing: LabstepExtension = {
  keymap: {
    ArrowUp: (state, dispatch) => handleArrowUp(state, dispatch!),
    ArrowDown: (state, dispatch) => handleArrowDown(state, dispatch!),
    Enter: (state, dispatch) => handleEnter(state, dispatch!),
    Escape: (state, dispatch) => handleEscape(state, dispatch!),
    [REFERENCING_TRIGGER]: (state, dispatch) =>
      handleTrigger(state, dispatch!),
  },
  plugins: [referencingPlugin],
};
